import { ResultOf } from '@graphql-typed-document-node/core';
import { useGraphQLQuery } from '@mp/hooks/useGraphQLRequest';
import { graphql } from '@mp/graphql/generated';

export const CurrentUserForPositionsAndSpecialtiesViewGql = graphql(`
  query GetCurrentUserForPositionsAndSpecialtiesView($id: Int!, $location_ids: [Int!]!) {
    me {
      professional {
        positions {
          id
          display_name
          kind
        }
        specialties {
          id
          label
        }
      }
    }
  }
`);

export const PositionsWithSpecialtiesForPositionsAndSpecialtiesViewGql = graphql(`
  query GetPositionsWithSpecialtiesForPositionsAndSpecialtiesView($input: PositionQueryInput) {
    positions(input: $input) {
      id
      display_name
      specialties {
        id
        label
      }
    }
  }
`);

export const usePositionsWithSpecialties = (professionalPositionIds: number[]) => {
  const { data: positionsWithSpecialties, isLoading: loadingPositions } = useGraphQLQuery<
    ResultOf<typeof PositionsWithSpecialtiesForPositionsAndSpecialtiesViewGql>
  >({
    operationName: 'GetPositionsWithSpecialtiesForPositionsAndSpecialtiesView',
    query: PositionsWithSpecialtiesForPositionsAndSpecialtiesViewGql,
    variables: {
      input: {
        search: {
          position_ids: professionalPositionIds,
        },
        filter: { active: true },
      },
    },
  });
  const allPositionsWithSpecialties = positionsWithSpecialties?.positions || [];

  return { allPositionsWithSpecialties, loadingPositions };
};

export const useCurrentUserForPositionsWithSpecialties = () => {
  const { data, isLoading: loadingUser } = useGraphQLQuery<
    ResultOf<typeof CurrentUserForPositionsAndSpecialtiesViewGql>
  >({
    operationName: 'GetCurrentUserForPositionsAndSpecialtiesView',
    query: CurrentUserForPositionsAndSpecialtiesViewGql,
    variables: {},
  });

  const currentUser = data?.me;

  return { currentUser, loadingUser };
};
